import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	fieldLabel: {
		marginBottom: 10,
		fontSize: 14,
		fontWeight: 500,
		color: colors.gray[800]
	},
	errorText: {
		marginTop: 4,
		fontSize: 12,
		color: colors.red[600]
	}
})

export default useStyles
